import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HttpConfig } from './configs/http.config';
import { ChunkErrorHandler } from './configs/chunk-error-handler';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { LoadingComponent } from './shareds/loading/loading.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PreviewFormsModule } from './shareds/preview-forms/preview-forms.module';

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LoadingComponent,
        ConfirmDialogModule,
        ToastModule,
        PreviewFormsModule], providers: [
        MessageService,
        ConfirmationService,
        { provide: ErrorHandler, useClass: ChunkErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: HttpConfig, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        providePrimeNG({ theme: { preset: Lara, options: { darkModeSelector: false } } }),
    ] })
export class AppModule { }
